import styled from "styled-components";

export const DailySettlementRabbitMainBoxWrapper = styled.div`
  width: 916px;
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  margin-top: 30px;
`;

export const DailySettlementRabbitMainTableWrapper = styled.div`
  display: grid;
  row-gap: 20px;
  column-gap: 20px;
  grid-template-columns: repeat(2, 1fr);
  margin-top: 20px;
  width: max-content;

  > .column {
    grid-column: 1 / -1;
  }
`;

export const DailySettlementRabbitMainTable = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 366px;

  > .header {
    display: flex;
    align-items: center;
    gap: 10px;
    position: relative;
  }

  > .wrapper {
    display: flex;
    width: 366px;
    flex-wrap: wrap;
    row-gap: 12px;
  }

  img {
    cursor: pointer;
  }
`;

export const DailySettlementRabbitMainTableItem = styled.div`
  display: flex;
  flex-direction: column;
  font-family: Pretendard;
  font-weight: 600;
  font-size: 15px;
  line-height: 30px;
  width: 182px;

  > .header {
    height: 30px;
    background: #ecf0f3;
    border: 1px solid #ecf0f3;
    border-right: 1px solid #d9d9d9;
    box-sizing: border-box;
    text-align: center;
    padding: 0 10px;
  }

  > .item {
    height: 30px;
    border: 1px solid #ecf0f3;
    border-right: 1px solid #d9d9d9;
    box-sizing: border-box;
    text-align: right;
    padding: 0 10px;
  }
`;

export const DailySettlementRabbitContentHeader = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;

  > .info {
    font-family: Pretendard;
    font-weight: 600;
    font-size: 15px;
    line-height: 100%;
    text-align: left;
    color: #b10003;
  }
`;
